const STT_PERMISSION_ACKNOWLEDGED_KEY = 'sttPermissionAcknowledged';

/**
 * @returns `true` = STT 활성화, `false` = STT 비활성화 (동의 절차는 거침), `null` = 아직 동의 절차를 거치지 않음
 */
export function getSttPermissionAcknowledged(): boolean | null {
  try {
    const value = localStorage.getItem(STT_PERMISSION_ACKNOWLEDGED_KEY);
    if (value === null) return null;
    return value === 'true';
  } catch {
    return null;
  }
}

export function setSttPermissionAcknowledged(value = true): void {
  try {
    localStorage.setItem(STT_PERMISSION_ACKNOWLEDGED_KEY, String(value));
  } catch {
    // localStorage 접근 불가 시 무시
  }
}

/**
 * Safari/iOS에서 SpeechRecognition OS 권한을 요청한다.
 * 권한이 허용되면 resolve, 거부(not-allowed/service-not-allowed)되면 reject.
 */
export async function requestSpeechRecognitionPermission(): Promise<void> {
  const SpeechRecognitionCtor =
    typeof SpeechRecognition !== 'undefined'
      ? SpeechRecognition
      : typeof webkitSpeechRecognition !== 'undefined'
        ? webkitSpeechRecognition
        : null;

  if (!SpeechRecognitionCtor) return;

  const recognition = new SpeechRecognitionCtor();
  recognition.continuous = false;
  recognition.interimResults = false;

  await new Promise<void>((resolve, reject) => {
    recognition.onstart = () => {
      recognition.abort();
    };

    recognition.onerror = (event: SpeechRecognitionErrorEvent) => {
      if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
        reject(new Error(event.error));
      }
      // 권한 에러를 제외한 나머지는 에러는 onend에서 resolve 처리
    };

    recognition.onend = () => {
      resolve();
    };

    try {
      recognition.start();
    } catch {
      resolve();
    }
  });
}
